import { Button } from '@/shared/ui/form/button';
import { styled } from 'styled-components';
export const WishlistButton = styled(Button)`
  border-radius: 8px;
  box-shadow: 0px 1px 1px 0px rgba(239, 241, 243, 0.08);
  &:hover {
    background: var(--2-c-344-a-60, rgba(44, 52, 74, 0.6));
  }

  @media (max-width: 768px) {
    flex-basis: 40px;
    padding: 0;
  }

  ${({ $isSelected }) =>
    $isSelected &&
    `
        background-color:#27262B;

    `}
`;

export const WishlistButtonMobile = styled(WishlistButton)`
  backdrop-filter: blur(8px);
  border-radius: 8px;
  width: 40px;
  box-shadow: 0px 1px 1px 0px rgba(239, 241, 243, 0.08) inset;
  ${({ $isSelected }) =>
    $isSelected &&
    `
        background-color:#27262B;
    `}
`;
